import invalidCartRedirectMiddleware from '#shared/middleware/invalidCartRedirectMiddleware.js';
import getCartMiddleware from '#shared/middleware/getCartMiddleware.js';
import paymentReturnMiddleware from '#shared/middleware/paymentReturnMiddleware.js';

import defaultConfirmOrder from '#themes/default/default/pages/confirmOrder/confirmOrder.js';

import cBillingSummary from '#themes/default/web/components/billingSummary/billingSummary.js';
import cButton from '#themes/default/web/components/button/button.js';
import cButtons from '#themes/default/web/components/buttons/buttons.js';
import cCompanySummary from '#themes/default/web/components/companySummary/companySummary.js';
import cHeader from '#themes/default/web/components/header/header.js';
import cInfoBox from '#themes/default/web/components/infoBox/infoBox.js';
import cLegalAgreement from '#themes/default/web/components/legalAgreement/legalAgreement.js';
import cLegalAgreementCheckbox from '#themes/default/web/components/legalAgreementCheckbox/legalAgreementCheckbox.js';
import cPaymentSummary from '#themes/default/web/components/paymentSummary/paymentSummary.js';

export default {
	middleware: [
		invalidCartRedirectMiddleware,
		getCartMiddleware,
		paymentReturnMiddleware
	],
	components: {
		cBillingSummary,
		cButton,
		cButtons,
		cCompanySummary,
		cHeader,
		cInfoBox,
		cLegalAgreement,
		cLegalAgreementCheckbox,
		cPaymentSummary
	},
	extends: defaultConfirmOrder
};
